export default number => {
    var nmb = number;
    var remaining = nmb % 250;
    if (remaining >= 125) {
        nmb += 250 - remaining;
    } else {
        nmb -= remaining;
    }
    return nmb;
}